import { useEffect, useRef } from "react";
import "./css/CheckboxField.css";

export default function QuestionField({
  id,
  name,
  className,
  label,
  value,
  onChange,
  isInvalid,
  error,
  help,
  labelStyle,
  disabled,
  ...props
}) {
  const checkbox = useRef();
  const computedClassName = [
    "form-group",
    "question-field",
    isInvalid ? "has-error" : "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  useEffect(() => {
    if (!!checkbox.current) {
      checkbox.current.addEventListener("change", (event) => {
        checkbox.value = event.currentTarget.checked;
      });
    }
  }, []);
  return (
    <div className={computedClassName}>
      <label for={id} style={labelStyle} className="control-label">
        {label}
      </label>
      <div className="checkbox">
        <label>
          <input
            ref={checkbox}
            id={id}
            name={name}
            type="checkbox"
            checked={value}
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
          {(value && "Si") || "No"}
        </label>
      </div>
      {isInvalid && !!error && (
        <span className="help-block col-lg-12">{error}</span>
      )}
    </div>
  );
}

QuestionField.defaultProps = {
  className: "",
  checked: false,
};
